import { type ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import { SCAOperation } from '@shinetools/sca-operations';
import { Squircle } from '@shinetools/sunshine-universal';

export type OperationDetails = {
  icon: ReactElement;
  title: ReactElement;
};

export const getOperationDetails = (operation: string) => {
  switch (operation) {
    case SCAOperation.CreateRecipient:
      return {
        icon: <Squircle backgroundColor="$blue.300" icon="profile" />,
        title: <FormattedMessage id="sca.operation.create_beneficiary" />,
      };
    case SCAOperation.EnrollTrustedDevice:
    case SCAOperation.EnrollTrustedDeviceWithEmail:
    case SCAOperation.NewDeviceRequest:
      return {
        icon: <Squircle backgroundColor="$blue.300" icon="shield" />,
        title: <FormattedMessage id="sca.operation.enroll_trusted_device" />,
      };

    case SCAOperation.ViewPaymentCardPin:
      return {
        icon: <Squircle backgroundColor="$blue.300" icon="card-recto" />,
        title: <FormattedMessage id="sca.operation.view_payment_card_pin" />,
      };

    case SCAOperation.EnrollMdaDevice:
      return {
        icon: <Squircle backgroundColor="$blue.300" icon="card-recto" />,
        title: <FormattedMessage id="sca.operation.enroll_mda_device" />,
      };

    default:
      throw new Error(`Operation ${operation} not handled`);
  }
};
